import styled from 'styled-components';
import { zLayoutNavigation } from 'core/styles/z-index';

export const StickyHeaderAreaDiv = styled.div`
  position: sticky;
  top: var(--maintenance-banner-height, 0px);
  z-index: ${zLayoutNavigation};
  background-color: ${({ theme }) => theme.colors.background};
`;
